import script from "./UserChat.vue?vue&type=script&setup=true&lang=js"
export * from "./UserChat.vue?vue&type=script&setup=true&lang=js"

import "./UserChat.vue?vue&type=style&index=0&id=4813efda&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4813efda"]])

export default __exports__